"use client"

import React, { useEffect, useState } from "react"
import { loadRefreshedBaskeAction } from "@/actions/basketActions"
import { useUbStorefrontState } from "@/store/ubStorefrontState"

import { getLinkWithPrefixFromURLAndLocale } from "@/lib/link-utils/link-utils"
import StoryblokCustomerTypeDialogClient from "@/components/storyblok/header/StoryblokCustomerTypeDialogClient"

interface RegistrationCustomerTypeSwitchGuardClientProps {
  expectedIsB2B: boolean
  currentIsB2B: boolean
  sbLocale: string
}

export default function RegistrationCustomerTypeSwitchGuardClient({
  expectedIsB2B,
  currentIsB2B,
  sbLocale,
}: RegistrationCustomerTypeSwitchGuardClientProps) {
  const [dialogVisible, setDialogVisible] = useState(false)
  const { setIsB2BCustomer, setIsLoading, setBasketData } = useUbStorefrontState()

  useEffect(() => {
    setIsB2BCustomer(currentIsB2B)
    setDialogVisible(expectedIsB2B !== currentIsB2B)
  }, [currentIsB2B, expectedIsB2B, setIsB2BCustomer])

  function cleanupCustomerTypeParams(url: URL) {
    //UBW-833 remove all combinations of params 'b2c' when switching customer type
    url.searchParams.delete("b2c")
    url.searchParams.delete("B2C")
    url.searchParams.delete("b2C")
    url.searchParams.delete("B2c")
  }

  function reloadCurrentPage() {
    setDialogVisible(false)
    setIsLoading(true)
    setTimeout(() => {
      setIsLoading(false)
    }, 2000)

    loadRefreshedBaskeAction().then((basketData) => {
      setBasketData(basketData)
      const url = new URL(window.location.href)
      cleanupCustomerTypeParams(url)
      window.location.href = url.href
    })
  }

  function switchBackToCurrentCustomerTypePage() {
    setDialogVisible(false)
    const targetUrl = getLinkWithPrefixFromURLAndLocale(
      currentIsB2B ? "/auth/signup/b2b" : "/auth/signup/b2c",
      sbLocale
    )
    const url = new URL(targetUrl, window.location.origin)
    cleanupCustomerTypeParams(url)
    window.location.href = url.href
  }

  if (!dialogVisible) {
    return null
  }

  return (
    <StoryblokCustomerTypeDialogClient
      onClose={reloadCurrentPage}
      onCancel={switchBackToCurrentCustomerTypePage}
      onSwitchComplete={reloadCurrentPage}
    />
  )
}
